/* eslint-disable consistent-return */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, connect } from 'react-redux';
import _ from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import BarChartRoundedIcon from '@material-ui/icons/BarChartRounded';
import LibraryAddOutlinedIcon from '@material-ui/icons/LibraryAddOutlined';
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
import RemoveCircleRounded from '@material-ui/icons/RemoveCircleRounded';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import CloseIcon from '@material-ui/icons/Close';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import { getDashboardList, getSageMaker } from '../../actions/dashboard/Dashboard';
import logo from '../../assets/images/logo.svg';
import useStyles from '../style';
import { getUserFavorites, addUserFavorites, deleteUserFavorite } from '../../actions/favorites/Favorites';
import { onBoarding, saveDetails } from '../../actions/user/User';
import { whatsNew } from '../../actions/whatsnew/WhatsNew';
import { faqs } from '../../actions/faqs/FAQs';
import { identityRegion, dashboardRegion } from '../../constants/Constants';
import {
  getAccessToken, getIdToken, arrangeMenuArray, isAuthenticated, getLoginUrl,
} from '../../utility/common';

const LeftDrawer = (props) => {
  const { mobileOpen } = props;
  const [open, setOpen] = useState(false);
  const [openNestedMenu, setNestedMenu] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(0);
  const theme = useTheme();
  const history = useHistory();
  const classes = useStyles();
  const dashboardData = useSelector((state) => state.getDashboardList);
  const sageMakerUrl = useSelector((state) => state.sageMakerUrl);
  let tree = null;
  const { dashboardListData, isDLSending } = dashboardData;
  const dashboardParams = {
    identityRegion,
    dashboardRegion,
    openIdToken: getIdToken(),
    accessToken: getAccessToken(),
  };
  const user = useSelector((state) => state.userOnBoarding);
  const fData = useSelector((state) => state.userFavorites);
  const getCurrentDashboard = useSelector((state) => state.getCurrentDashboard);
  const whatsNewData = useSelector((state) => state.getWhatsNew);
  const faqsStoreData = useSelector((state) => state.getFaqs);

  useEffect(() => {
    props.onBoarding(dashboardParams);
    props.getSageMaker(dashboardParams, 'load');
    props.whatsNew(dashboardParams);
    props.faqs(dashboardParams);
    props.getUserFavorites(dashboardParams);
  }, []);
  const { isOnBoardingSuccess, isOnBoardingSending } = user;
  useEffect(() => {
    if (isOnBoardingSuccess) {
      props.getDashboardList(dashboardParams);
      props.saveDetails(dashboardParams);
    }
  }, [isOnBoardingSuccess]);

  if (dashboardListData && Array.isArray(dashboardListData) && dashboardListData.length > 0) {
    tree = arrangeMenuArray(dashboardListData);
  }

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDrawerToggle = () => {
    props.handleDrawerToggle();
  };

  const handleRedirect = (toPath, index, isPermanent) => {
    if (!isPermanent) {
      handleDrawerToggle();
    }
    const checkPath = toPath.lastIndexOf('/');
    let path = '/';
    if (checkPath === -1) {
      path = `/${toPath}`;
    } else {
      path = `${toPath}`;
    }
    handleListItemClick(index);
    history.push(path);
  };

  const handleReport = (path, dashboard, index, isPermanent) => {
    if (!isPermanent) {
      handleDrawerToggle();
    }
    handleListItemClick(index);
    history.push(`/${path}`, dashboard);
  };

  const handleChildMenu = (event) => {
    const { id } = event.currentTarget;
    const prevState = { ...openNestedMenu };
    prevState[id] = !prevState[id];
    setNestedMenu(prevState);
  };

  const reportListItems = (childUiClass, node, children, index, isPermanent) => {
    let childnodes = null;
    if (children) {
      childnodes = children.map((childnode) => reportListItems('inner-menu', childnode, childnode.children, childnode.id, isPermanent));
    }
    return (
      <div key={`rmenu${index}`}>
        { node.DashboardId !== '' ? (
          <List component="div" disablePadding className={childUiClass}>
            <ListItem button className={classes.nested} onClick={() => handleReport('reports', node, 6 + index, isPermanent)} selected={selectedIndex === 6 + index}>
              <ListItemIcon className="nested-menu" />
              <ListItemText primary={node.Name} />
            </ListItem>
          </List>
        ) : (
          <ListItem button onClick={(e) => handleChildMenu(e)} id={node.id} className={childUiClass}>
            <ListItemIcon />
            <ListItemText primary={node.Name} />
            {openNestedMenu[node.id] ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
        )}
        {childnodes ? (
          <Collapse
            in={openNestedMenu[node.id]}
            timeout="auto"
            unmountOnExit
            className={classes.reportScroll}
          >
            {childnodes}
          </Collapse>
        ) : null }
      </div>
    );
  };
  const getReportMenus = (isPermanent) => {
    if (tree && Array.isArray(tree) && tree.length > 0) {
      return tree.map((value) => reportListItems('outer-class', value, value.children, value.id, isPermanent));
    }
    return null;
  };

  const { sageMakerURLData, isSageMakerUrlExist, isSMURLSuccess } = sageMakerUrl;

  useEffect(() => {
    if (sageMakerURLData && sageMakerURLData.length > 0) {
      // eslint-disable-next-line no-undef
      window.open(sageMakerURLData, '_blank');
    }
  }, [isSMURLSuccess]);

  const redirectSageMaker = () => {
    props.getSageMaker(dashboardParams, 'click');
  };

  // Favorites functionality start
  // eslint-disable-next-line consistent-return
  const handleDeleteFavorite = (selectedFavorite) => {
    const userFavList = fData.fData;
    if (!isAuthenticated()) {
      window.location.href = getLoginUrl();
      return null;
    }
    const favData = _.remove(userFavList, (obj) => obj.Name !== selectedFavorite.Name);
    const requestParams = {
      data: {
        data: favData,
      },
      openIdToken: getIdToken(),
      accessToken: getAccessToken(),
    };
    props.deleteUserFavorite(requestParams);
  };
  const getUserFavoritesList = (isPermanent) => {
    const favoritesData = fData.fData;
    if (favoritesData && Array.isArray(favoritesData) && favoritesData.length > 0) {
      const options = favoritesData.map((favoritesList, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <List component="div" disablePadding className="user-fav" key={`fav${index}`}>
          <ListItemIcon onClick={() => handleDeleteFavorite(favoritesList)}>
            <RemoveCircleRounded className={classes.removeIcon} />
          </ListItemIcon>
          <ListItem button className={classes.nested} onClick={() => handleReport('reports', favoritesList, 6 + index, isPermanent)} selected={selectedIndex === 6 + index}>
            <ListItemText primary={favoritesList.Name} />
          </ListItem>
        </List>
      ));
      return options;
    }
    return null;
  };

  const checkRequestReport = () => window.location.pathname.indexOf('request-report') > -1 || window.location.pathname.indexOf('user-guide') > -1;

  // eslint-disable-next-line consistent-return
  const addFavourites = () => {
    if (!isAuthenticated()) {
      window.location.href = getLoginUrl();
      return null;
    }
    if (checkRequestReport()) {
      return false;
    }
    const { currentDashboard } = getCurrentDashboard;
    let favData = fData.fData;
    let isFavoriteExist = false;
    if (favData && Array.isArray(favData) && favData.length > 0) {
      const checkFavorite = _.find(favData, { DashboardId: currentDashboard.DashboardId });
      if (!checkFavorite) {
        favData.push(currentDashboard);
      } else {
        isFavoriteExist = true;
      }
    } else {
      favData = [currentDashboard];
    }
    const requestParams = {
      data: {
        data: favData,
      },
      openIdToken: getIdToken(),
      accessToken: getAccessToken(),
    };
    if (!isFavoriteExist) {
      props.addUserFavorites(requestParams);
    }
  };

  const openPDF = (type) => {
    if (!isAuthenticated()) {
      window.location.href = getLoginUrl();
      return null;
    }
    const { wData } = whatsNewData;
    const { faqsData } = faqsStoreData;
    let content = wData;
    if (type === 'faqs') {
      content = faqsData;
    }
    if (content) {
      // eslint-disable-next-line new-cap
      const bufferData = new Buffer.from(content, 'base64');
      // eslint-disable-next-line no-undef
      const file = new Blob([bufferData], {
        type: 'application/pdf',
      });
      // Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      // eslint-disable-next-line no-undef
      window.open(fileURL, '_blank');
    }
  };

  // Favorites functionality end
  const getListItems = (isPermanent) => (
    <div>
      <Backdrop className={classes.backdrop} open={isOnBoardingSending || isDLSending}>
        <CircularProgress className={classes.loaderColor} />
      </Backdrop>
      <CardMedia
        component="svg"
        alt="McDonald"
        height="170px"
        width="140px"
        image={logo}
        preserveAspectRatio="xMidYMid meet"
        title="McDonald"
        className={classes.logo}
      />
      <ListItem button onClick={() => handleRedirect('/', 0, isPermanent)} selected={selectedIndex === 0} className={classes.dashBoardListItem}>
        <ListItemIcon>
          <DashboardOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
      <ListItem button onClick={() => openPDF('whatsnew')}>
        <ListItemIcon>
          <CheckCircleOutlineRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="What's New" />
      </ListItem>
      <ListItem button onClick={handleClick}>
        <ListItemIcon>
          <BarChartRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Reports" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        className={classes.reportScroll}
      >
        {getReportMenus(isPermanent)}
      </Collapse>
      <ListItem button onClick={() => handleRedirect('request-reports', 2, isPermanent)} selected={selectedIndex === 2}>
        <ListItemIcon>
          <LibraryAddOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Request Reports" />
      </ListItem>
      <Divider variant="middle" className={classes.styledDivider} />
      <ListItem button onClick={() => addFavourites('favourites', 3, isPermanent)} selected={selectedIndex === 3} disabled={checkRequestReport()}>
        <ListItemIcon>
          <AddCircleRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Add Favorites" />
      </ListItem>
      {getUserFavoritesList(isPermanent)}
      {isSageMakerUrlExist && (
        <ListItem button className={classes.sageMaker} onClick={() => redirectSageMaker()}>
          <ListItemIcon>
            <InfoOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Data Science" />
        </ListItem>
      )}
      <ListItem button className={!isSageMakerUrlExist ? classes.userGuideMenu : ''} onClick={() => handleRedirect('user-guide', 5, isPermanent)} selected={selectedIndex === 5}>
        <ListItemIcon>
          <InfoOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="User Guide" />
      </ListItem>
      <ListItem button className={classes.faqsMenu} onClick={() => openPDF('faqs')}>
        <ListItemIcon>
          <HelpOutlineOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="FAQs" />
      </ListItem>
    </div>
  );

  return (
    <div className="left-menu">
      <div className={classes.drawerContainer}>
        <Hidden smUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            className="temp-drawer"
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <IconButton onClick={handleDrawerToggle} className={classes.closeMenuButton}>
              <CloseIcon />
            </IconButton>
            {getListItems(false)}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            // className="nav-menu"
          >
            <Drawer
              variant="permanent"
              className="nav-menu"
              classes={{ paper: classes.drawerpaper }}
            >
              {getListItems(true)}
            </Drawer>
          </List>
        </Hidden>
      </div>
    </div>
  );
};

/** Required function and props with the proptypes */
LeftDrawer.propTypes = {
  mobileOpen: PropTypes.bool.isRequired,
  getDashboardList: PropTypes.func.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  getSageMaker: PropTypes.func.isRequired,
  onBoarding: PropTypes.func.isRequired,
  getUserFavorites: PropTypes.func.isRequired,
  addUserFavorites: PropTypes.func.isRequired,
  deleteUserFavorite: PropTypes.func.isRequired,
  saveDetails: PropTypes.func.isRequired,
  whatsNew: PropTypes.func.isRequired,
  faqs: PropTypes.func.isRequired,
};

const mapDispatchedToProps = {
  getDashboardList,
  addUserFavorites,
  getUserFavorites,
  getSageMaker,
  onBoarding,
  deleteUserFavorite,
  saveDetails,
  whatsNew,
  faqs,
};

export default connect(null, mapDispatchedToProps)(LeftDrawer);
